import httpAuth from "@/common/http-common";
import {
  Dashboard2Snapshot,
  createEmptyDashboard2Snapshot
} from "@/views/dashboard2/types/dashboard2.types";

class Dashboard2Service {
  async getDashboardSnapshot(
    clientId: number,
    participantId: number,
    timezone?: string,
    startDate?: string,
    endDate?: string
  ): Promise<Dashboard2Snapshot> {
    const { data } = await httpAuth().get<Dashboard2Snapshot>(
      "/Dashboard/GetDashboard2Snapshot",
      {
        params: {
          clientId,
          participantId,
          startDate,
          endDate,
          timezone: timezone || "UTC"
        }
      }
    );
    return data;
  }

  // Temporary helper while UI transitions from embedded constants to API-backed data.
  getDashboardSnapshotMock(): Dashboard2Snapshot {
    return createEmptyDashboard2Snapshot();
  }
}

export default new Dashboard2Service();
